/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceDetails } from './InvoiceDetails';
import {
    InvoiceDetailsFromJSON,
    InvoiceDetailsFromJSONTyped,
    InvoiceDetailsToJSON,
    InvoiceDetailsToJSONTyped,
} from './InvoiceDetails';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
    SubscriptionToJSONTyped,
} from './Subscription';
import type { ProductWithMetadata } from './ProductWithMetadata';
import {
    ProductWithMetadataFromJSON,
    ProductWithMetadataFromJSONTyped,
    ProductWithMetadataToJSON,
    ProductWithMetadataToJSONTyped,
} from './ProductWithMetadata';

/**
 *
 * @export
 * @interface BillingDetails
 */
export interface BillingDetails {
    /**
     *
     * @type {boolean}
     * @memberof BillingDetails
     */
    billingEnabled: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BillingDetails
     */
    hasActiveSubscription: boolean;
    /**
     *
     * @type {Subscription}
     * @memberof BillingDetails
     */
    subscription: Subscription | null;
    /**
     *
     * @type {InvoiceDetails}
     * @memberof BillingDetails
     */
    nextInvoice: InvoiceDetails | null;
    /**
     *
     * @type {Array<ProductWithMetadata>}
     * @memberof BillingDetails
     */
    products: Array<ProductWithMetadata>;
}

/**
 * Check if a given object implements the BillingDetails interface.
 */
export function instanceOfBillingDetails(value: object): value is BillingDetails {
    if (!('billingEnabled' in value) || value['billingEnabled'] === undefined) return false;
    if (!('hasActiveSubscription' in value) || value['hasActiveSubscription'] === undefined) return false;
    if (!('subscription' in value) || value['subscription'] === undefined) return false;
    if (!('nextInvoice' in value) || value['nextInvoice'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function BillingDetailsFromJSON(json: any): BillingDetails {
    return BillingDetailsFromJSONTyped(json, false);
}

export function BillingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetails {
    if (json == null) {
        return json;
    }
    return {

        'billingEnabled': json['billing_enabled'],
        'hasActiveSubscription': json['has_active_subscription'],
        'subscription': SubscriptionFromJSON(json['subscription']),
        'nextInvoice': InvoiceDetailsFromJSON(json['next_invoice']),
        'products': ((json['products'] as Array<any>).map(ProductWithMetadataFromJSON)),
    };
}

  export function BillingDetailsToJSON(json: any): BillingDetails {
      return BillingDetailsToJSONTyped(json, false);
  }

  export function BillingDetailsToJSONTyped(value?: BillingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'billing_enabled': value['billingEnabled'],
        'has_active_subscription': value['hasActiveSubscription'],
        'subscription': SubscriptionToJSON(value['subscription']),
        'next_invoice': InvoiceDetailsToJSON(value['nextInvoice']),
        'products': ((value['products'] as Array<any>).map(ProductWithMetadataToJSON)),
    };
}
